import { z } from 'zod';
import { EmailSchema, PhoneSchema, TenantIdSchema, TrnSchema } from './primitives';

export const ErpTypeSchema = z.enum([
  'SAP',
  'Oracle',
  'Dynamics365',
  'Zoho',
  'NetSuite',
  'Tally',
  'Other',
]);

export const IntegrationModeSchema = z.enum(['API', 'Portal', 'FileUpload']);
export const MfaMethodSchema = z.enum(['TOTP', 'SMS', 'Email', 'UAE_PASS']);

export const OnboardingStatusSchema = z.enum([
  'PENDING',
  'ACTIVE',
  'SUSPENDED',
  'TERMINATED',
]);

export const TenantSchema = z.object({
  tenantId: TenantIdSchema,
  companyNameEn: z.string().min(1).max(200),
  companyNameAr: z.string().min(1).max(200),
  trn: TrnSchema,
  contactName: z.string().min(1).max(100),
  contactEmail: EmailSchema,
  contactPhone: PhoneSchema,
  erpType: ErpTypeSchema.default('Other'),
  integrationMode: IntegrationModeSchema.default('Portal'),
  mfaMethod: MfaMethodSchema.default('TOTP'),
  onboardingStatus: OnboardingStatusSchema.default('PENDING'),
  createdAt: z.string().datetime(),
  activatedAt: z.string().datetime().nullable().default(null),
});
export type Tenant = z.infer<typeof TenantSchema>;
